import { render } from "./member-table.vue?vue&type=template&id=af5672ea"
import script from "./member-table.vue?vue&type=script&lang=js"
export * from "./member-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__